import PropTypes from "prop-types";

const SizeMappingsTable = ({ sizeMappings }) => {
  if (!sizeMappings || sizeMappings.length === 0) {
    return <div>No size mappings available.</div>;
  }

  return (
    <table className="min-w-full max-w-screen overflow-scroll">
      <thead>
        <tr className="bg-black text-white">
          <th className="p-2 text-left">Brand size</th>
          <th className="p-2 text-left">US</th>
          <th className="p-2 text-left">FR</th>
          <th className="p-2 text-left">UK</th>
        </tr>
      </thead>
      <tbody>
        {sizeMappings.map((mapping, index) => (
          <tr key={mapping.psize} className={index % 2 === 0 ? "bg-offWhite" : ""}>
            <td className="p-2">{mapping.psize}</td>
            <td className="p-2">{mapping.canonicalSizes.join(", ")}</td>
            <td className="p-2">{parseInt(mapping.canonicalSizes[0], 10) + 32}</td>
            <td className="p-2">{parseInt(mapping.canonicalSizes[0], 10) + 2}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

SizeMappingsTable.propTypes = {
  sizeMappings: PropTypes.arrayOf(
    PropTypes.shape({
      psize: PropTypes.string.isRequired,
      canonicalSizes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};

export default SizeMappingsTable;
